var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/danger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M181.833 132.666L128.5 36.666C121.333 23.7494 111.417 16.666 100.5 16.666C89.5834 16.666 79.6667 23.7494 72.5001 36.666L19.1667 132.666C12.4167 144.916 11.6667 156.666 17.0834 165.916C22.5001 175.166 33.1667 180.249 47.1667 180.249H153.833C167.833 180.249 178.5 175.166 183.917 165.916C189.333 156.666 188.583 144.833 181.833 132.666Z",
    fill: "#F0CA08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M100.5 122.917C97.0833 122.917 94.25 120.083 94.25 116.667V75C94.25 71.5833 97.0833 68.75 100.5 68.75C103.917 68.75 106.75 71.5833 106.75 75V116.667C106.75 120.083 103.917 122.917 100.5 122.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M100.5 150C100 150 99.4168 149.917 98.8334 149.833C98.3334 149.75 97.8334 149.583 97.3334 149.333C96.8334 149.167 96.3334 148.917 95.8334 148.583C95.4167 148.25 95.0001 147.917 94.5834 147.583C93.0834 146 92.1667 143.833 92.1667 141.667C92.1667 139.5 93.0834 137.333 94.5834 135.75C95.0001 135.417 95.4167 135.083 95.8334 134.75C96.3334 134.417 96.8334 134.167 97.3334 134C97.8334 133.75 98.3334 133.583 98.8334 133.5C99.9168 133.25 101.083 133.25 102.083 133.5C102.667 133.583 103.167 133.75 103.667 134C104.167 134.167 104.667 134.417 105.167 134.75C105.583 135.083 106 135.417 106.417 135.75C107.917 137.333 108.833 139.5 108.833 141.667C108.833 143.833 107.917 146 106.417 147.583C106 147.917 105.583 148.25 105.167 148.583C104.667 148.917 104.167 149.167 103.667 149.333C103.167 149.583 102.667 149.75 102.083 149.833C101.583 149.917 101 150 100.5 150Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4221b725f10c82349f30059ec84fa22d.svg";
export { ForwardRef as ReactComponent };